import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Unities = () => {
  return (
    <div className='m-1'>
      <Title text="Unidades"/>
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Unities